import { createSelector } from 'reselect';

import { AppState } from '../../store/store';
import { SearchHistoryState } from './search-history-reducer';
import { SearchResultItem } from '../components/header/search-navigation/searchbar/search-autocomplete/search-autocomplete-hook';

const searchHistoryState = (state: AppState): SearchHistoryState => state.searchHistory;

export const searchHistorySelector = createSelector(searchHistoryState, state => {
    const searchHistory: SearchResultItem[] = state.searchHistory.map((item, index) => ({ id: index, name: item }));
    return searchHistory;
});
